import { CdkDragDrop, CdkDragEnd, CdkDragStart, transferArrayItem } from '@angular/cdk/drag-drop';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnInit, Renderer2, signal, TemplateRef, ViewChild, ViewEncapsulation, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CountableTimeZonePipe } from 'countable@helpers';
import { SPIN_STYLES, SpinInputModel } from 'countable@model';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, finalize } from 'rxjs/operators';
import { BillingModel } from 'src/app/model/billing/billing.model';
import { ExportPDFModel } from 'src/app/model/export.model';
import { FirmModel } from 'src/app/model/firm/firm.model';
import { idleTime } from 'src/app/services/app-config';
import { BillingService } from 'src/app/services/billing.service';
import { ExcelService } from 'src/app/services/excel.service';
import { FirmService } from 'src/app/services/firm.service';
import { TimeTrackerService } from 'src/app/services/time-tracker.service';
import { AclModel } from '../../../../model/acl.model';
import { HeaderNameModel } from '../../../../model/workbook/header-name.model';
import { AclService } from '../../../../services/acl.service';
import { ApiService } from '../../../../services/api.service';
import { AuthService } from '../../../../services/auth.service';
import { EngApiService } from '../../../../services/eng-api.service';
import { EngService } from '../../../../services/eng.service';
import { JournalService } from '../../../../services/journal.service';
import { TbApiService } from '../../../../services/tb-api.service';
import { WorkbookService } from '../../../../services/workbook.service';
import { SharedService } from '../../../shared/shared.service';

@Component({
  selector: 'app-trial-balance-ls-grouping',
  templateUrl: './trial-balance-ls-grouping.component.html',
  styleUrls: ['./trial-balance-ls-grouping.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class TrialBalanceLsGroupingComponent implements OnInit {
  private subject: Subject<string> = new Subject();
  mapNumData: any;
  mappingDataSource: any;
  tokenDetails: any;
  trailbalId: any;
  isMapping: boolean = false;
  showContent: boolean = false;
  isMappingNum = 0;
  tbMapSheetId: number;
  engagementData: any;
  userData: any;
  getLeadsheetGroupingDetails: any = [];
  originalLeadsheetGroupingDetails: any = [];
  selectedTBLrow: any = [];
  isChangesMove: boolean = false;
  isLeadSheet: boolean = false;
  isSaveLeadsheet: boolean = false;
  isExpanded: boolean = true;
  @ViewChild('createLeadsheetDialog') createLeadsheetDialog: TemplateRef<any>;
  @ViewChild('saveLeadsheetDialog') saveLeadsheetDialog: TemplateRef<any>;
  @ViewChild('saveMapNoDialog') saveMapNoDialog: TemplateRef<any>;
  @ViewChild('multipleMoveMenu') multipleMoveMenu: MatMenuTrigger;
  @ViewChild('notes') notes: MatMenuTrigger;
  @ViewChild('headerNotesColumn3Field') headerNotesColumn3Field: ElementRef;
  @ViewChild('deletenoteDialog') deletenoteDialog: TemplateRef<any>;
  mapsheetid: any;
  savenotedetect: boolean;
  cancelnotedetect: boolean;
  leadSheetDetails: any;
  leadsheetid: any;
  dialogRef: any;
  mapNodialogRef: any;
  isSingleRecordSave: boolean = true;
  engagementYearEnd: any;
  leadSheetGroup: any[];
  leadSheetCodeDetails: any[];
  addLeadSheetForm: UntypedFormGroup;
  leadSheetDetailsCopy: any;
  leadSheetName: any;
  mapNo: any;
  workBookSubModuleId: any;
  headerNotesColumn1: string = '';
  headerNotesColumn2: string = '';
  headerNotesColumn3: string = '';
  clientName: any;
  yearEndDetails: any = [];
  selectedYearEnd: any;
  selectedYearTitle: string;
  notesList: any = [];
  deleteNotesData: any = [];
  isSecondColumnClicked: boolean = false;
  isThirdColumnClicked: boolean = false;
  isOldSecondColumn: string = '';
  isOldThirdColumn: string = '';
  changeType: string = 'percentage';
  headerSubmoduleNameSubscription: Subscription;
  notesDetails: any;
  connectedTo = [];
  activeLsMove: boolean = false;
  activeMapMove: boolean = false;
  TbLeadSheetId: number;
  menuPosition: string;
  confirmLeadsheetSub: Subscription;
  bulkMapSubscription: Subscription;
  moveButtonSubscription: Subscription;
  isDisableMoveButton: boolean = true;
  adjustment: any;
  adjustmentGroupDetails: any = [];
  displayedColumns2: string[] = ['entryno', 'ref', 'total'];
  filteredItems: any = [];
  lsMenuPopupHeight = 88;
  initialYaxis = 0;
  changeInValueWRTls = 0;
  changeInValueWRTmap = 0;
  leadsheetPopupHeight = 535;
  mapNumberPopupHeight = 691;
  selectedLSmenuPositions = [];
  isSearchExist: boolean = true;
  searchText: string = '';
  // edlabel:any;
  hideMoveButton: boolean = true;
  leadsheetdisable: boolean = false;
  unAssignSingleMap: Subscription;
  shortCutMenuDetails: any;
  acl: AclModel;
  trackobj: { engagementsId: any; submoduleId: any; submoduleUuid: any; };
  userActivity;
  userInactiveSub: Subscription;
  userInactive: Subject<any> = new Subject();
  isActionCharterLimitExceed = false;
  firm: FirmModel;
  billing: BillingModel;
  private allSubscriptions: Subscription = new Subscription();
  private userSelectedChange: string;
  private scrollInterval: any;
  private currentPointerPosition: { x: number; y: number } = { x: 0, y: 0 };
  private globalListeners: (() => void)[] = [];
  private isScrolling: boolean = false;
  public spinnerConfig: WritableSignal<SpinInputModel> = signal<SpinInputModel>(new SpinInputModel(null,SPIN_STYLES.LINE));
  private spinCount: number = 0;


  @HostListener('window:mousemove', ["$event"])
  @HostListener('window:resize', ["$event"])
  @HostListener('window:keydown', ["$event"])
  refreshUserState() {
    clearTimeout(this.userActivity);
    if (localStorage.getItem("timerStatus") == "Idle")
      this.trackerService.startTimer("Active");
    this.setTimeout();
  }
  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    localStorage.setItem("isOpenWB", "false");
  }

  @HostListener('window:storage', ['$event'])
  onStorageChange(ev: StorageEvent) {
    if (ev.key === 'docReferenceUpdated') {
      if (this.router.url == '/trial-balance-working-sheet/tb-ls-grouping'){
        this.getLeadsheetGroupingData();
        localStorage.removeItem('docReferenceUpdated');
      }
    }
  }

  constructor(private apiService: ApiService, private excelService: ExcelService, public sharedService: SharedService,
              public dialog: MatDialog, private toastr: ToastrService, public router: Router,private countableTimeZonePipe: CountableTimeZonePipe,
              private fb: UntypedFormBuilder, @Inject(DOCUMENT) private document: Document,
              private trackerService: TimeTrackerService, private toaster: ToastrService, private firmService: FirmService,private renderer: Renderer2,
              private billingService: BillingService, private cdr: ChangeDetectorRef, private authService: AuthService, private aclService: AclService,
              private wbService: WorkbookService, private engApiService: EngApiService, private tbApiService: TbApiService, private journalService: JournalService,
              private engService: EngService) {
    this.authService.subjectUserDetail.pipe(takeUntilDestroyed()).subscribe(detail => {
      this.userData = detail;
    });
    this.aclService.subject.pipe(takeUntilDestroyed()).subscribe(acl => {
      this.acl = acl;
    });
    this.setTimeout();
    this.userInactive.subscribe(() => {
      this.trackerService.startTimer("Idle");
    });
    this.allSubscriptions.add(
      this.firmService.subject.subscribe(firm => {
       if (firm) {
           this.firm = firm;
       }
     })
    );
   this.allSubscriptions.add(
    this.billingService.subject.subscribe(billing => {
     if (billing) {
         this.billing = billing;
     }
    }));
  }

  ngOnInit() {
    localStorage.removeItem("refreshFinancialStatements-LSG");
    this.engagementData = JSON.parse(localStorage.getItem("selectedEngagementObj"));
    let selectedObj = JSON.parse(localStorage.getItem("selectedEngagementObjCopy"));
    this.engagementYearEnd = localStorage.getItem("endYear");
    this.clientName = selectedObj.clientName
    this.workBookSubModuleId = localStorage.getItem('workBookSubmoduleId');
    this.shortCutMenuDetails = JSON.parse(localStorage.getItem('shortCutMenuDetails'));
    this.getTBLSHeaderNotes();
    this.getYearEndDetails();
    this.getLeadsheetGroupingData();
    this.trackobj = {
      "engagementsId": this.engagementData.engagementsid,
      "submoduleId": JSON.parse(localStorage.getItem("workBookSubmoduleId")),
      "submoduleUuid": localStorage.getItem("WUUID"),
    }
    localStorage.setItem("timeTrackerObj", JSON.stringify(this.trackobj));
    this.trackerService.startTimer("Active");
    this.addLeadSheetForm = this.fb.group({
      leadSheetName: ['', Validators.required],
      groupName: ['', Validators.required],
      subGroupName: ['', Validators.required],
      leadSheetCode: ['', Validators.required],
    });

    this.headerSubmoduleNameSubscription = this.sharedService.leftSideMenuNameChange.subscribe(response => {
      if (response) {
        this.getTBLSHeaderNotes();
      }
    });

    this.confirmLeadsheetSub = this.sharedService.isMovingLeadsheet.subscribe(res => {
      if (res.subscribeFrom === "LSG") {
        if (res.moveType === "SINGLE") {
          if (res.moveFrom === "LS") {
            this.confirmSaveLeadsheet(res.parent, res.child);
          }
          else {
            this.confirmSaveMapNo(res.parent, res.child);
          }
        }
        else {
          this.isDisableMoveButton = res.isDisableMoveButton;
          if (res.moveFrom === "LS") {
            this.leadSheetData(res.child);
          }
          else {
            this.mapSheetData(res.child);
          }
        }
      }
    });

    this.bulkMapSubscription = this.sharedService.isBulkMap.subscribe(response => {
      if (response) {
        this.getLeadsheetGroupingData();
        this.clearSelection();
      }
    });

    this.unAssignSingleMap = this.sharedService.unAssignMapNumber.subscribe(res => {
      if (res) {
        this.saveUnMappingItems(res);
      }
    });

    this.subject.pipe(
      // if character length greater then 2
      filter(res => res.length > 2 || res.length < 3)
      // Time in milliseconds between key events
      , debounceTime(1000)
      // If previous query is diffent from current
      , distinctUntilChanged()
    ).subscribe((text: string) => {
      // this.getLeadsheetGroupingData();
      this.filterLeadsheetGroupingData(text);
    });

    this.moveButtonSubscription = this.sharedService.hideMoveButton.subscribe(response => {
      this.hideMoveButton = response != true;
    });
  }
  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), idleTime);
  }
  getExpandCollapse(type) {
    if (type === 'true') {
      this.isExpanded = true;
      this.getLeadsheetGroupingDetails.forEach(element => {
        element.isexpand = true;
      });
    } else {
      this.isExpanded = false;
      this.getLeadsheetGroupingDetails.forEach(element => {
        element.isexpand = false;
      });
    }
  }

  trackByParentRecord(index, item) {
    return index;
  }

  trackByChildRecord(index, item) {
    return index;
  }

  focusInput() {
    setTimeout(() => {
      this.headerNotesColumn3Field.nativeElement.focus();
    }, 2);
  }

  onDragMoved(event) {
    if (event.delta.y === 1) {
      this.document.getElementById('TBGrid').scrollTop += 10;
    } else {
      this.document.getElementById('TBGrid').scrollTop -= 10;
    }
  }

  getTBLSHeaderNotes() {
    let engId = this.engagementData.engagementsid;
    let subModuleId = this.workBookSubModuleId;

    this.wbService.getWbHeaderNote(engId, subModuleId).subscribe({
      next: res => {
        if (res?.status === 200  && res?.data) {
          let results = JSON.parse(res?.data);
          this.headerNotesColumn1 = results[0].header[0].changednameline1;
          this.headerNotesColumn2 = results[0].header[0].changednameline2;
          this.headerNotesColumn3 = results[0].header[0].changednameline3;
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  getYearEndDetails() {
    this.engService.getEngagementYearDetails(this.engagementData.engagementsid).subscribe(response => {
      if (response) {
        let yearEndDetails = response;
        this.yearEndDetails = yearEndDetails;
        this.selectedYearEnd = this.yearEndDetails[0].acctyear;
        this.engagementYearEnd = this.yearEndDetails[0].acctdate;
      }
    }, error => {
      this.toastr.error("Error in getting Year End Details");
    })
  }

  mouseEnterHandler(event: MouseEvent, openExpansionPanel: MatExpansionPanel) {
    if (event.buttons && !openExpansionPanel.expanded) {
      openExpansionPanel.open();
    }
  }

  changePosition(event, checkboxLevel) {
    setTimeout(() => {
      const span: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
      if (span != null) {
        const child: HTMLElement = document.querySelector('.cdk-overlay-pane');
        if (child) {
          child.style.left = '0';
          child.style.top = '0';
        }
        let popupSize = !this.activeMapMove && !this.activeLsMove ? this.lsMenuPopupHeight : this.activeMapMove ? this.mapNumberPopupHeight : this.leadsheetPopupHeight;
        span.style.left = (event.x + 20) + 'px';
        if ((document.documentElement.clientHeight - event.screenY - 35) >= popupSize) {
          span.style.top = ((event.pageY + 10) < 0 ? 0 : (event.pageY + 10)) + 'px';
          span.style.bottom = "auto";
        } else {
          span.style.top = ((event.pageY - popupSize) < 0 ? 0 : (event.pageY - popupSize)) + 'px';
          span.style['margin-top'] = 0;
          span.style.top = ((event.pageY - popupSize - 25) < 0 ? 0 : (event.pageY - popupSize - 25)) + 'px';
        }

        // if (checkboxLevel != 'child2') {
        let menuStyles = {
          'left': span.style.left,
          'top': span.style.top,
          'bottom': span.style.bottom,
          'id': checkboxLevel.ttrailbalanceid,
          'overflow': 'auto'
        }

        let matchFound = false;
        let dialogCenterHeight = '0';
        for (let i = 0; i < this.selectedLSmenuPositions.length; i++) {
          if (this.selectedLSmenuPositions[i].id === checkboxLevel.ttrailbalanceid) {
            this.selectedLSmenuPositions.splice(i, 1);
            i = this.selectedLSmenuPositions.length;
            matchFound = true;
            this.activeMapMove = false;
            this.activeLsMove = false;
            this.initialYaxis = 0;
          }
        }
        if (matchFound === false) {
          this.selectedLSmenuPositions.push(menuStyles);
        }
        else {
          dialogCenterHeight = ((document.documentElement.clientHeight - 220) / 2) - (popupSize / 2) + 220 + 'px'
        }

        let stylesElement = this.selectedLSmenuPositions[this.selectedLSmenuPositions.length - 1];
        if (stylesElement) {
          span.style.top = matchFound ? dialogCenterHeight : stylesElement.top;
          span.style.bottom = stylesElement.bottom;
          span.style.left = stylesElement.left;
          span.style.overflow = 'auto';
        }
        if (this.activeMapMove) { this.changeInValueWRTmap = parseInt(span.style['top']); }
        if (this.activeLsMove) { this.changeInValueWRTls = parseInt(span.style['top']); }
      }
      const menuDiv: HTMLElement = document.querySelector('#LSMAPDialog');
      if (menuDiv)
        menuDiv.style.display = 'flex';
    }, 200);
  }

  saveHeaderNote() {
    const headerNameModel: HeaderNameModel = {
      subModuleId: this.workBookSubModuleId,
      engId: this.engagementData.engagementsid,
      changedNameLine2: this.headerNotesColumn2,
      changedNameLine3: this.headerNotesColumn3,
      isDelete: 0
    }

    this.updateSpinnerConfig(true);
    this.wbService.saveChangeWbHeaderName(headerNameModel).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.toastr.success('Header details updated successfully');
          this.isSecondColumnClicked = false;
          this.isThirdColumnClicked = false;
          this.getTBLSHeaderNotes();
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  toggleChange(type: "percentage" | "doller") {
    this.changeType = type;
  }

  handleSearch(searchTerm: string) {
    this.subject.next(searchTerm);
  }

  // editablelabel(label:string){
  //   this.edlabel =label;
  //   console.log("editable"+ this.edlabel)
  // }

  getAdjustmentGroupDetails(value) {
    this.adjustmentGroupDetails = [];
    let obj = {
      "engagementid": this.engagementData.engagementsid,
      "acctyear": this.selectedYearEnd,
      "trailbalanceid": value.ttrailbalanceid
    };
    let finalObj = JSON.stringify(obj);
    this.updateSpinnerConfig(true);
    this.journalService.getTbRecordAdjType(finalObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          let result = JSON.parse(res?.data);
          this.adjustmentGroupDetails = new MatTableDataSource(result);
        }
      }, error: e => {
        this.toastr.warning(e.error);
      }
    })
  }

  drop(event: CdkDragDrop<any[]>) {
    if (!event.isPointerOverContainer) {
      console.info("Dropped outside the grid, resetting...");
      return;
    }
    let obj = [];

    if (event.previousContainer !== event.container) {
      const leadsheetId = event.container.data[0].leadsheetid;
      const mastermapsheetid = event.container.data[0].mastermapsheetid;
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);

      obj = [{
        trailbalanceid: event.item.data.ttrailbalanceid,
        leadsheetid: Number(leadsheetId),
        mastermapsheetid: mastermapsheetid,
        loginid: this.userData['useracctid']
      }]

      let objJson = {
        "leadsheetchange": obj
      }

      let saveobj = JSON.stringify(objJson)
      this.updateSpinnerConfig(true);
      this.tbApiService.saveLeadSheetGrouping(saveobj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
        next: res => {
          this.getCfForchangedLeadsheet(obj, leadsheetId);
          this.clearSelection();
          this.refreshFinancialStatements();
          this.toastr.success('Moved successfully');
        }, error: e => {
          this.clearSelection();
          this.toastr.error(e.error);
          this.getLeadsheetGroupingData();
        }
      });
    }
  }
  exportToExcel() {
    this.updateSpinnerConfig(true);
    var req_cols = ['LS', 'Map.No', 'Acc.No', 'Description', 'Original', 'Adjusting', 'Final', 'PY1', 'Change'];
    let engagementDetails: any = this.engagementData
    this.userSelectedChange = this.changeType == 'percentage' ? 'tchangepercentage' : 'tdlchanges';

    var columnkeys = [
      { key: 'leadsheetcode' },
      { key: 'tmapno' },
      { key: 'taccountcode' },
      { key: 'taccountname' },
      { key: 'toriginalbalance' },
      { key: 'tadjustmentamount' },
      { key: 'tfinalamount' },
      { key: 'tpy1' },
      { key: this.userSelectedChange }
    ];
    var temparray = []
    var temptotindexaaray = []
    var finaltotindex;
    var sum: any = 6;
    var totindex = [];
    this.getLeadsheetGroupingDetails.forEach(element => {
      if (element.hasOwnProperty("TBrecords")) {
        var len = element.TBrecords.length;
        temptotindexaaray.push(len);
      }
      if (element.TBrecords && element.TBrecords.length) {
        element.TBrecords.forEach(e => {
          temparray.push(e)
        });
        var tobj = {
          // 'leadsheetcode':element.leadsheetcode,
          // 'tmapno':element.tmapno,
          'taccountname': 'Total ' + element.leadsheetname,
          'toriginalbalance': element.originaltotal,
          'tadjustmentamount': element.adjustmentamountotal,
          'tfinalamount': element.finaltotal,
          'tpy1': element.py1,
          // 'tchangepercentage': element.changepercentage
        }
        temparray.push(tobj)
      }
    });
    for (let i = 0; i < temptotindexaaray.length; i++) {
      sum += temptotindexaaray[i] + 1;
      totindex.push(sum);
    }
    let edlabel: any = this.headerNotesColumn2
    finaltotindex = totindex;
    let finalTrailBalDetails = temparray // Group total is added in excel sheet
    this.excelService.exportToExcel(this.userSelectedChange,finalTrailBalDetails, engagementDetails, this.selectedYearTitle, columnkeys, this.headerNotesColumn1, req_cols, finaltotindex, edlabel);
    this.updateSpinnerConfig(false);
  }

  exportTrailBalanceGrouping() {
    const Obj : ExportPDFModel = new ExportPDFModel();
    Obj.id = this.engagementData.engagementsid;
    Obj.year = this.selectedYearEnd;
    Obj.isChangeInDollar = !(this.changeType === 'percentage');
    //console.log('exportAdobePdf-Inputs',Obj);
    const fileName = 'Trial Balance Grouping.pdf';
    this.updateSpinnerConfig(true);
    this.sharedService.exportService.exportTrailBalanceGrouping(Obj,fileName).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: response => {
        if(response){
          this.toastr.success('Download Successfull')
        } else {
          this.toastr.error('Download Failed')
        }
      },
      error: error => {
        console.log('Error',error);
        this.toastr.error('An error occurred during export.');
      }
    });
  }

  getLeadsheetGroupingData() {
    this.connectedTo = [];
    this.yearEndDetails.forEach(element => {
      if (element.acctyear === this.selectedYearEnd) {
        this.engagementYearEnd = element.acctdate;
      }
    });

    let search = this.searchText ? this.searchText : '';
    let getObj = {
      "engagementsid": this.engagementData.engagementsid,
      "acctyear": parseInt(this.selectedYearEnd ? this.selectedYearEnd : this.countableTimeZonePipe.transform(this.engagementData.yearEnd, 'yyyy', 'UTC')),
      "searchindex": search
    }
    let finalObj = JSON.stringify(getObj)

    this.updateSpinnerConfig(true);
    this.tbApiService.getLeadSheetGrouping(finalObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.getLeadsheetGroupingDetails = JSON.parse(res?.data);
          this.originalLeadsheetGroupingDetails = JSON.parse(res?.data);
          this.getLeadsheetGroupingDetails.forEach((element, index) => {
            if (index === (this.getLeadsheetGroupingDetails.length - 1)) {
              this.isSearchExist = element.searchexist == 1;
              if (element.searchexist === 0) {
                this.toastr.warning('No records found');
              }
            } else {
              this.connectedTo.push(element.leadsheetidcode);
            }
          });
          this.isChangesMove = false;
        }
      }, error: e => {
        this.toastr.warning(e.error);
      }
    })
  }

  getNotesDetails(data) {
    data.addNotes = false;
    data.viewNotes = false;
    data.viewNotesDetails = false;

    if (data.Notes > 0) {
      data.addNotes = false;
      data.viewNotes = true;

      this.updateSpinnerConfig(true);
      this.engApiService.getEngNote(this.engagementData.engagementsid, data.ttrailbalanceid).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
        next: res => {
          if (res.status === 200) {
            this.notesList = res.data ? JSON.parse(res.data) : [];
          }
        }, error: e => {
          this.toastr.error(e.error)
        }
      });
    } else {
      data.addNotes = true;
      data.viewNotes = false;
      data.engNoteId = 0;
      this.sharedService.isProcedureEditor = true;
    }
  }

  getShortName(fullName) {
    return fullName.split(' ').map(n => n[0]).join('');
  }

  addNewNotes(leadSheetData) {
    leadSheetData.addNotes = true;
    leadSheetData.viewNotes = false;
    leadSheetData.selectedNotes = '';
    leadSheetData.engNoteId = 0;
    this.sharedService.isProcedureEditor = true;

  }

  viewNotes(leadSheetData, notes) {
    leadSheetData.addNotes = false;
    this.sharedService.isProcedureEditor = false
    leadSheetData.viewNotes = false;
    leadSheetData.viewNotesDetails = true;
    this.notesDetails = notes;
    this.cancelnotedetect = true;
  }

  cancelNote(leadSheet) {
    if(leadSheet){
    leadSheet.selectedNotes = "";
    leadSheet.addNotes = false;
    leadSheet.viewNotes = false;
    }
    this.cancelnotedetect = true;
    this.sharedService.isProcedureEditor = false;
  }


  outsidedirective(value) {
    // console.log("data=", this.getLeadsheetGroupingDetails)
    // console.log("dsfsd", value.selectedNotes);
    if (value.selectedNotes && this.sharedService.isProcedureEditor) {
      this.toaster.error("Please save/cancel changes made to the note before proceeding");
    }
  }
  backToView(leadSheetData) {
    leadSheetData.addNotes = false;
    leadSheetData.viewNotes = true;
    leadSheetData.viewNotesDetails = false;
    this.sharedService.isProcedureEditor = false;

  }

  editNotes(leadSheetData, notes) {
    leadSheetData.addNotes = true;
    leadSheetData.viewNotes = false;
    leadSheetData.viewNotesDetails = false;
    leadSheetData.selectedNotes = notes.description;
    leadSheetData.engNoteId = notes.engnoteid;
    this.sharedService.isProcedureEditor = true;

  }

  saveNotes(data) {
    if (data.selectedNotes && data.selectedNotes.trim()) {
      let obj = [{
        "engagementsid": this.engagementData.engagementsid,
        "submoduleid": parseInt(this.workBookSubModuleId),
        "refpkeyid": data.ttrailbalanceid,
        "description": data.selectedNotes,
        "engnoteid": data.engNoteId ? data.engNoteId : 0,
        "isdelete": 0
      }]

      let detail = {'engnote': obj};

      this.updateSpinnerConfig(true);
      this.engApiService.saveEngNote(JSON.stringify(detail)).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
        next: res => {
          if (res.status === 200 && res.data) {
            this.toastr.success('Notes created successfully');
            this.getLeadsheetGroupingData();
            this.sharedService.sendNotifySubject.next({'uuid': this.userData.useracctid, 'isfirm': 1});
          }
        }, error: e => {
          this.toastr.error(e.error);
          this.sharedService.isProcedureEditor = false;
        }
      });
      this.cancelNote(data);
    }else{
      this.cancelNote(data);
    }
  }

  deleteNoteDailog(leadSheetData, data) {
    // leadSheetData.addNotes = false;
    // leadSheetData.viewNotes = false;
    // leadSheetData.viewNotesDetails = false;
    // this.sharedService.isProcedureEditor=false;
    this.deleteNotesData = [{
      "engagementsid": this.engagementData.engagementsid,
      "submoduleid": parseInt(this.workBookSubModuleId),
      "refpkeyid": leadSheetData.ttrailbalanceid,
      "description": data.description,
      "loginid": this.userData['useracctid'],
      "engnoteid": data.engnoteid ? data.engnoteid : 0,
      "isdelete": 1
    }];

    const dialogRef = this.dialog.open(this.deletenoteDialog, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
     // console.log('res', result);
      result ? this.deleteNoteYes() : this.deleteNoteNo();

    });
  }

  deleteNoteYes() {
    let detail = {'engnote': this.deleteNotesData};
    let finalObj = JSON.stringify(detail)
    this.updateSpinnerConfig(true);
    this.engApiService.saveEngNote(finalObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res.data) {
          this.toastr.success('Notes deleted successfully');
          this.getLeadsheetGroupingData();
          this.sharedService.sendNotifySubject.next({'uuid': this.userData.useracctid, 'isfirm': 1});
        }
      }, error: e => {
        this.toastr.error(e.error);
        this.notes.closeMenu();
      }
    });
  }

  deleteNoteNo() {
    this.deleteNotesData = [];
  }

  checkLSChange(checkeditem) {
    if (checkeditem.checked == true) {
      this.selectedTBLrow.push(checkeditem)
    }
    else {
      this.selectedTBLrow.map((x, index) => {
        if (x.ttrailbalanceid == checkeditem.ttrailbalanceid) {
          this.selectedTBLrow.splice(index, 1);
          //x.checked=false;
        }
      })
    }

    let unmappedcount = 0;
    this.selectedTBLrow.map(element => {
      if (element.mastermapsheetid === 0 || element.mastermapsheetid === null) {
        unmappedcount = unmappedcount + 1
      }
    });

    if (unmappedcount > 0) {
      this.leadsheetdisable = true;
    } else {
      this.leadsheetdisable = false;
    }

    if (this.selectedTBLrow.length > 1) {
      this.isSingleRecordSave = false;
      this.multipleMoveMenu.openMenu();
      const menuDiv: HTMLElement = document.querySelector('#LSMAPDialog');
      menuDiv.style.display = 'none';
      this.menuPosition = "translate3d(-22px, 300px 0px)";
    } else {
      this.isSingleRecordSave = true;
      this.multipleMoveMenu.closeMenu();
    }
  }

  activeMultiLS(obj, event) {
    obj.isLeadSheet = true;
    this.TbLeadSheetId = 0;

    this.hideMoveButton = true;

    const span: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
    if (this.initialYaxis === 0) {
      this.initialYaxis = event.clientY;
    }
    if (!this.activeMapMove && !this.activeLsMove) {
      if ((document.documentElement.clientHeight - this.initialYaxis - 35) <= this.leadsheetPopupHeight) {
        span.style['top'] = parseInt(span.style['top']) - (this.leadsheetPopupHeight - (document.documentElement.clientHeight - this.initialYaxis) - 20) + 'px';
        if (parseInt(span.style['top']) < 0) {
          span.style['top'] = "0px";
        }

        span.style['height'] = (this.mapNumberPopupHeight < (document.documentElement.clientHeight - parseInt(span.style['top'])) ? this.mapNumberPopupHeight :
          this.leadsheetPopupHeight < (document.documentElement.clientHeight - parseInt(span.style['top'])) ? this.leadsheetPopupHeight :
            (document.documentElement.clientHeight - parseInt(span.style['top']))) + "px";
      }
    } else {
      if (this.activeLsMove)
        span.style['top'] = this.changeInValueWRTls + "px";
      else
        span.style['top'] = this.changeInValueWRTmap + "px";
    }
    this.changeInValueWRTls = parseInt(span.style['top']);
    this.activeLsMove = true;
    this.activeMapMove = false;
  }

  activeMultiMapNo(obj, event) {
    obj.isMap = true;
    this.tbMapSheetId = 0;
    this.hideMoveButton = true;

    const span: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
    if (this.initialYaxis === 0) {
      this.initialYaxis = event.clientY;
    }
    if (!this.activeMapMove && !this.activeLsMove) {
      if ((document.documentElement.clientHeight - this.initialYaxis - 35) <= this.mapNumberPopupHeight) {
        span.style['top'] = parseInt(span.style['top']) - (this.mapNumberPopupHeight - (document.documentElement.clientHeight - this.initialYaxis) - 20) + 'px';
        if (parseInt(span.style['top']) < 0) {
          span.style['top'] = "0px";
        }
        span.style['height'] = (this.mapNumberPopupHeight < (document.documentElement.clientHeight - parseInt(span.style['top'])) ? this.mapNumberPopupHeight :
          this.leadsheetPopupHeight < (document.documentElement.clientHeight - parseInt(span.style['top'])) ? this.leadsheetPopupHeight :
            (document.documentElement.clientHeight - parseInt(span.style['top']))) + "px";
      }
    } else {
      if (this.activeMapMove)
        span.style['top'] = this.changeInValueWRTmap + "px";
      else
        span.style['top'] = this.changeInValueWRTls + "px";
    }
    this.changeInValueWRTmap = parseInt(span.style['top']);
    this.activeMapMove = true;
    this.activeLsMove = false;
  }

  activeLSDropdown(obj) {
    if (this.isSingleRecordSave) {
      obj.isLeadSheet = true;
    }
  }

  mappingNumber(obj) {
    if (this.isSingleRecordSave) {
      obj.isMap = true;
      this.tbMapSheetId = obj.mastermapsheetid;
    }
  }

  //create leadsheet
  createLeadsheetItem() {
    const dialogRef = this.dialog.open(this.createLeadsheetDialog, {
      panelClass: 'my-dialog-container-class'
    });
  }

  //map sheet details
  mapSheetData(value) {
    this.mapsheetid = value.mastermapsheetid;
  }

  //lead sheet details
  leadSheetData(value) {
    this.leadsheetid = value.leadsheetid;
  }

  //save mapping details
  savemappingdetails() {
    let mapdetails = [];
    if (this.selectedTBLrow) {
      this.selectedTBLrow.map(x => {
        mapdetails.push({
          "trailbalanceid": x.ttrailbalanceid,
          "mapsheetid": this.mapsheetid,
          "acctyear": parseInt(this.selectedYearEnd ? this.selectedYearEnd : this.countableTimeZonePipe.transform(this.engagementData.yearEnd, 'yyyy')),
          "loginid": this.userData['useracctid']
        })
      })
    }
    let MappingObj = {
      "tbmapping": mapdetails
    }
    let finalSaveMappingObj = JSON.stringify(MappingObj);
    this.updateSpinnerConfig(true);
    this.tbApiService.saveNewTbMapping(finalSaveMappingObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.getCfForchangedMapsheet(this.selectedTBLrow, this.mapsheetid);
          this.toastr.success('Map no. moved successfully');
          this.isSingleRecordSave = true;
          this.selectedTBLrow = [];
          this.mapsheetid = '';
          this.isChangesMove = false;
          this.activeMapMove = false;
          this.activeLsMove = false;
          this.refreshFinancialStatements();
          this.clearSelection();
          this.multipleMoveMenu.closeMenu();
          this.sharedService.sendNotifySubject.next({'uuid': this.userData.useracctid, 'isfirm': 1});
        } else {
          this.toastr.success('Failed to move mapping');
        }
      }, error: e => {
        this.toastr.error(e.error);
        this.clearSelection();
        this.multipleMoveMenu.closeMenu();
      }
    });
  }

  saveUnMappingItems(data) {
    let trialbalanceId = data.yearType === "PREVIOUS" ? data.parent.prevtrailbalanceid : data.parent.ttrailbalanceid;
    let inputObject = [{
      "trailbalanceid": trialbalanceId,
    }]
    var finalSaveMappingObj = JSON.stringify({
      "unmapping": inputObject
    })

    this.updateSpinnerConfig(true);
    this.tbApiService.unMap(finalSaveMappingObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res.data) {
          this.toastr.success('Unmapped successfully');
          this.refreshFinancialStatements();
          this.getLeadsheetGroupingData();
        } else {
          this.toastr.error('Unmapping failed');
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  clearSelection() {
    this.clearSelectedData();
    this.getLeadsheetGroupingDetails.map(x => {
      if (x.TBrecords) {
        x.TBrecords.map(y => {
          if (y.checked == true) {
            y.checked = false
          }
        })
      }
    })
    this.multipleMoveMenu.closeMenu();
  }

  clearSelectedData() {
    const parent: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
    if (parent)
      parent.style['margin-top'] = 0;
    this.selectedTBLrow = [];
    this.selectedLSmenuPositions = [];
    this.isDisableMoveButton = true;
    this.activeMapMove = false;
    this.activeLsMove = false;
    this.isSingleRecordSave = true;
    this.changeInValueWRTmap = 0;
    this.changeInValueWRTls = 0;
    this.initialYaxis = 0;
  }

  clearRowSelection() {
    this.selectedTBLrow = [];
    this.leadsheetid = '';
  }

  //save leadsheet details
  saveLeadSheetdetails() {
    var mapdetails = []
    if (this.selectedTBLrow) {
      this.selectedTBLrow.map(x => {
        mapdetails.push({
          "trailbalanceid": x.ttrailbalanceid,
          "leadsheetid": this.leadsheetid, "mastermapsheetid": x.mastermapsheetid, "loginid": this.userData['useracctid']
        })
      })
    }
    var leadSheetObj = {
      "leadsheetchange": mapdetails
    }
    var finalSaveMappingObj = JSON.stringify(leadSheetObj)
    this.updateSpinnerConfig(true);
    this.tbApiService.saveLeadSheetGrouping(finalSaveMappingObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.getCfForchangedLeadsheet(this.selectedTBLrow, this.leadsheetid);
          this.toastr.success('Leadsheet moved Successfully');
          this.isSingleRecordSave = true;
          this.isLeadSheet = false;
          this.selectedTBLrow = [];
          this.leadsheetid = '';
          this.isChangesMove = false;
          this.isDisableMoveButton = true;
          this.activeMapMove = false;
          this.activeLsMove = false;
          this.refreshFinancialStatements();
          this.clearSelection();
          this.multipleMoveMenu.closeMenu();
        } else {
          this.toastr.success('Failed to move Lead Sheet');
        }
      }, error: e => {
        this.toastr.error(e.error);
        this.clearSelection();
        this.multipleMoveMenu.closeMenu();
      }
    });
  }

  confirmSaveLeadsheet(value, LSData) {
    this.leadsheetid = LSData.leadsheetid
    this.leadSheetName = LSData.leadsheetcode + "-" + LSData.leadsheetname
    this.selectedTBLrow = []
    var leadSheetObj = {
      "leadsheetcode": value.leadsheetcode,
      "leadsheetid": value.leadsheetid,
      "leadsheetname": value.leadsheetname,
      "mastermapsheetid": value.mastermapsheetid,
      "taccountcode": value.taccountcode,
      "taccountname": value.taccountname,
      "tadjustmentamount": value.tadjustmentamount,
      "tfinalamount": value.tfinalamount,
      "tfingroupid": value.tfingroupid,
      "tmapno": value.tmapno,
      "toriginalbalance": value.toriginalbalance,
      "ttrailbalanceid": value.ttrailbalanceid
    }
    this.selectedTBLrow.push(leadSheetObj);
    this.dialogRef = this.dialog.open(this.saveLeadsheetDialog, { disableClose: true });
  }

  confirmSaveMapNo(value, MapSheet) {
    this.mapNo = MapSheet.mapno
    this.mapsheetid = MapSheet.mastermapsheetid
    this.selectedTBLrow = []
    var mapSheetObj = {
      "leadsheetcode": value.leadsheetcode,
      "leadsheetid": value.leadsheetid,
      "leadsheetname": value.leadsheetname,
      "mastermapsheetid": value.mastermapsheetid,
      "taccountcode": value.taccountcode,
      "taccountname": value.taccountname,
      "tadjustmentamount": value.tadjustmentamount,
      "tfinalamount": value.tfinalamount,
      "tfingroupid": value.tfingroupid,
      "tmapno": value.tmapno,
      "toriginalbalance": value.toriginalbalance,
      "ttrailbalanceid": value.ttrailbalanceid
    }
    this.selectedTBLrow.push(mapSheetObj);
    this.dialog.open(this.saveMapNoDialog, { disableClose: true });
  }

  refreshLeadSheetGrouping() {
    this.getLeadsheetGroupingData();
    this.selectedTBLrow = [];
  }



  ngOnDestroy() {
    clearTimeout(this.userActivity);
    if (this.headerSubmoduleNameSubscription) {
      this.headerSubmoduleNameSubscription.unsubscribe();
    }

    if (this.confirmLeadsheetSub) {
      this.confirmLeadsheetSub.unsubscribe();
    }
    if (this.bulkMapSubscription) {
      this.bulkMapSubscription.unsubscribe();
    }

    if (this.moveButtonSubscription) {
      this.moveButtonSubscription.unsubscribe();
    }

    if (this.unAssignSingleMap) {
      this.unAssignSingleMap.unsubscribe();
    }
    this.allSubscriptions && this.allSubscriptions.unsubscribe();
  }

  refreshFinancialStatements() {
    this.sharedService.refreshWorkbookmenu.next(true);
    localStorage.setItem('refreshFinancialStatements-LSG', "success");
    localStorage.setItem('refreshTrialbalance', "success");
  }

  getCfForchangedLeadsheet(leadDetails, leadsheetid) {
    let leadSheetId = Number(leadsheetid);
    this.updateSpinnerConfig(true);
    this.sharedService.apiService.getMappingFromLeadSheet(leadSheetId).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {
      if(response){
        this.saveCashFlow(leadDetails,JSON.parse(response).cashFlowTypeId, JSON.parse(response).cashFlowTypeName)
      }
    }, error => {
      console.log("error");
      this.getLeadsheetGroupingData();
    });
  }

  //
  getCfForchangedMapsheet(mapdetails, mapsheetid) {
    this.sharedService.apiService.getCFTypeFromMapSheet(mapsheetid).subscribe(response => {
      if(response){
        this.saveCashFlow(mapdetails,JSON.parse(response).id, JSON.parse(response).name)
      }
    }, error => {
      console.log("error");
      this.getLeadsheetGroupingData();
    });
  }


  saveCashFlow(array, cashFlowId, cashFlowName) {
    //console.log(array)
    var data = {
      "loginId": this.userData['useracctid'],
      "engagementsId": this.engagementData.engagementsid,
      "leadsheetId": array[0].leadsheetid,
      "action": "update",
      "cashFlowTypeId": cashFlowId,
      "cashFlowTypeName": cashFlowName,
      "trialBalanceIds": [],
      "isDelete": 0,
      "isOldCFUnmapped": false
    }

    array.forEach(element => {
      element?.cashFlow ? '' : data.isOldCFUnmapped = true;
      data.trialBalanceIds.push(element?.ttrailbalanceid ? element.ttrailbalanceid : element.trailbalanceid);
    });
    this.updateSpinnerConfig(true);
    this.sharedService.apiService.saveCashFlowRowInTb(data).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {

      this.getLeadsheetGroupingData();
    }, error => {
      console.log("error");
      this.getLeadsheetGroupingData();
    });
  }

  checkActionCharterlength(value) {
    if (value.length > 255) {
      this.isActionCharterLimitExceed = true;
      this.toaster.error('Character limit for adding notes exceeded');
    } else {
      this.isActionCharterLimitExceed = false;
    }
  }

  filterLeadsheetGroupingData(searchTerm) {
    this.connectedTo = [];
    if (!searchTerm) {
      this.getLeadsheetGroupingDetails = JSON.parse(JSON.stringify(this.originalLeadsheetGroupingDetails.slice()));
      this.isSearchExist = false;
      this.cdr.detectChanges();
    } else {
      let temp = JSON.parse(JSON.stringify(this.originalLeadsheetGroupingDetails.slice()));
      this.getLeadsheetGroupingDetails = temp.map(group => {
        let foundMatch = false;
        if (group.TBrecords) {
          group.TBrecords.forEach(record => {
            if (record.taccountname.toLowerCase().includes(searchTerm.toLowerCase())) {
              record.isexpand = "true";
              record.ishighlight= "true";
              foundMatch = true;
              this.isSearchExist = true;
            } else {
              record.isexpand = "false"
            }
          });
        }
        group.isexpand = foundMatch ? "true" : "false";
        this.connectedTo.push(group.leadsheetidcode);
        return group;
      });
      this.isChangesMove = false;
      this.cdr.detectChanges();
    }
  }

  onDragStarted(event: CdkDragStart): void {
    this.globalListeners.push(
      this.renderer.listen(document, 'mousemove', (e: MouseEvent) => {
        this.currentPointerPosition = { x: e.clientX, y: e.clientY };
      }),
      this.renderer.listen(document, 'touchmove', (e: TouchEvent) => {
        this.currentPointerPosition = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      })
    );

    const container = document.querySelector('.auto-scroll-container') as HTMLElement;
    if (!container) return;

    this.isScrolling = true;

    this.scrollInterval = setInterval(() => {
      if (!this.isScrolling) return;

      const rect = container.getBoundingClientRect();
      const maxSpeed = 50; // Increase max speed for faster scrolling
      let scrollSpeed = 10; // Base speed

      if (this.currentPointerPosition.y > rect.bottom - 60) {
        scrollSpeed = Math.min(scrollSpeed * 2, maxSpeed); // Accelerate scrolling
        container.scrollTop += scrollSpeed;
      } else if (this.currentPointerPosition.y < rect.top + 60) {
        scrollSpeed = Math.min(scrollSpeed * 2, maxSpeed); // Accelerate scrolling
        container.scrollTop -= scrollSpeed;
      }
    }, 10); // Reduce interval for smoother scrolling
  }

  onDragEnded(event: CdkDragEnd): void {
    this.globalListeners.forEach((unlisten) => unlisten());
    this.globalListeners = [];
    this.isScrolling = false;
    clearInterval(this.scrollInterval); // Stop scrolling immediately
  }

  private updateSpinnerConfig(value: boolean) {
      value ? this.spinCount++ : (this.spinCount = Math.max(0, this.spinCount - 1));
      const spinner = this.spinnerConfig();
      this.spinnerConfig.set({
       ...spinner,
         isSpinShown: this.spinCount > 0
       });

     }

}
